import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The structure and functioning of aquatic ecosystems are being
              altered due to anthropogenic activities, evident from the
              deteriorating physicochemical conditions, sustained inflow of
              nutrients through untreated wastewater, eutrophication, declining
              vegetation cover in the catchment, increased grazing pressure,
              etc. (Ramachandra <em>et al</em>.,2020). Microalgae, being the
              primary producers or autotrophs, are crucial for aquatic ecosystem
              stability, and the composition of species indicates the ecological
              health of waterbodies as an ecological indicator. Hence,
              microalgae are a dependable tool for assessing the ecological
              status and water quality of wetlands (Crossetti &amp;
              Bicudo,2005). Algae are unicellular or multicellular, eukaryotic
              or prokaryotic (Asulabha <em>et al.</em>, 2022). In nature,
              microalgae are abundant and omnipresent, requiring different
              nutrients and temperatures. Algae can survive in a wide range of
              habitats, including freshwater, marine, hypersaline conditions,
              etc., and species vary in size, shape, colour, behaviour, and
              habitat (Khalil <em>et al.</em>,2021). Freshwater microalgal
              groups include Chlorophyta, Cyanobacteria, Rhodophyta, Euglenoids,
              Eustigmatophyta, Chrysophyta, Haptophyta, Synurophyta,
              Bacillariophyta, Pyrrhophyta, Cryptophyta, and Phaeophyta (Wehr{" "}
              <em>et al</em>.,2015).
            </p>
            <p>
              Microalgae, the primary producers in aquatic ecosystems, play a
              crucial role in the aquatic food chain in transferring materials
              and energy. Microalgal population density, diversity, and
              composition vary depending on the ecological health of aquatic
              ecosystems and hence aid as crucial water quality indicators
              (Zhang <em>et al</em>.,2021). Investigations of algal assemblages
              offer a sensitive, valuable, and quantitative representation of
              ecological changes (Paerl <em>et al</em>.,2003) and aid in
              pollution monitoring because of their large population, quick pace
              of development, affordable cost, easy maintenance, and ability to
              respond quickly to low pollution levels. Algae are valuable
              indicators of the extent of water quality degradation and its
              short-term effects, as the prevalence of blue-green algae
              indicates eutrophic conditions in water bodies. In contrast, the
              dominance of green algae and diatoms indicates oligotrophic
              conditions (Khan <em>et al</em>.,2011).
            </p>
            <p>
              Sustained discharge of untreated industrial effluent, domestic
              sewage, agriculture, and urban runoff alters the chemical
              integrity of aquatic ecosystems, as evidenced by water quality
              degradation and the composition of algal species. Water quality
              parameters BOD, COD, DO, pH, nitrogenous compounds, cations, and
              anions indicate physicochemical elements influencing phytoplankton
              species assemblages (Mohammed &amp; Mahran,2022). Microalgae,
              which are sensitive to water quality variations, help understand
              the extent of water contamination and aid in economically
              monitoring and managing ecosystems.
            </p>
            <p>
              Changes in the climate due to global warming with escalating
              greenhouse gas (GHG) footprint have necessitated an exploration of
              ecologically feasible, economically viable, and environmentally
              sound energy options to address the challenges of dwindling stock
              of fossil fuels and the need for mitigating GHG footprint.
              Bio-based feedstocks, such as microalgal biomass, have emerged as
              a viable alternative due to higher photosynthetic efficiency,
              lipid accumulation, shorter cycling time, and efficient carbon
              sequestration apart from the scope of a viable alternative to
              fossil fuels. Selecting an appropriate algal strain based on
              unique characteristics, including cellular contents, growth
              behaviour, and metabolic pathways, is crucial for biorefinery
              processes and products (Sarma <em>et al</em>.,2021). The current
              study through biomonitoring investigates (i) the diversity and the
              economic worth of microalgae in Hebbal-Nagavara Valley lakes, and
              (ii) explores the scope of third-generation feedstock for a
              sustainable and cost-effective biorefinery.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
